<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="user_role == 1">
            <div class="container-fluid xyz">
                <div class="admin-page-content pb-0">  

                    <div class="page-name">List Users</div>
                    <!--<button type="button" id='exportUsers' class="btn btn-secondary"
                    v-on:click="exportUsersData($event)">
                    Export
                    </button>-->
                    <!--button type="submit" v-on:click.prevent="gotoDraggableHRList" class="btn btn-secondary">HR Team List</button-->
                </div>
                <div class="container-fluid xyz">
                    <!--page content-->
                    <div class="admin-page-content">

                        <div class="app-filter-good-table-container">
                            <vue-good-table
                                ref="hrteamList"
                                mode="remote"
                                title="List User"
                                @on-page-change="onPageChange"
                                @on-selected-rows-change="selectionChanged"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                @on-sort-change="onSortChange"
                                :totalRows="totalRecords"
                                :columns="columns"
                                :rows="rows"
                                :pagination-options="{
                                enabled: true,
                                mode: 'pages',
                                pageLabel: 'Page',
                                position: 'bottom',
                                perPage: serverParams.perPage,
                                perPageDropdown: [25, 50, 100, 200 ,500],
                                dropdownAllowAll: false,
                                }"
                                :selectOptions="{
                                enabled: false,
                                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                selectionInfoClass: 'custom-class',
                                selectionText: 'rows selected',
                                clearSelectionText: 'clear',
                                }"
                                :search-options="{
                                enabled: false,
                                }">

                                <div slot="selected-row-actions" slot-scope="computed">
                                    {{computed.selectedRows}}
                                    <!--<button data-toggle="modal" title='Send mail to all' class="btn btn-primary" v-on:click.prevent="loadModel('btnsendmailall')" >Send Mail To All {{totalRecords}}</button>
                                    <button data-toggle="modal" title='Send mail to selected' class="btn btn-primary" v-on:click.prevent="loadModel('btnsendmail')" >Send Mail To Selected</button>-->
                                    <button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="deleteHrTeam()">Delete User ({{selectedRows}})</button>
                                </div>

                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <!--class="btn btn-xs btn-primary"-->
                                        <div v-if="props.column.field == 'action'">
                                            <router-link v-if="loginID != props.row.id" title='Edit User' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'AddUpdateUsers',params:{id:props.row.id}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                                            <!--<button title='Delete User' id="delete" class="btn edit-btn-vvg waves-effect"  v-on:click.prevent="deleteHrTeam(props.row.id)"><i class="fa fa-trash-o" aria-hidden="true"></i></button>-->
                                        </div>
                                        <div v-else>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>
                            </vue-good-table>
                        </div>
                    </div>
                    <!--page content-->
                </div>
            </div>

        </template>
        <template v-else-if="user_role == 0">

        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            We are Sorry!
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import SessioMixin from '../../../mixins/sessionmixin';
    import {commonMixins} from '../../../mixins/commonMixins';
    import { HTTP } from '../../../http-common';

    var self;
    export default {
        name: 'ListDiscounts',
        components: {
            'app-footer': Footer,
        },
        mixins: [SessioMixin, commonMixins],
        data() {
            return {
                loginID: 0,
                error: '',
                exportUsers: false,
                modelTitle: '',
                modelButtonId: '',
                subject: '',
                subjectError: '',
                message: '',
                messageError: '',
                filesAttachment: [],
                firstLoad: 0,
                columns: [
                    /*{
                     label: 'ID',
                     field: 'id',
                     filterable: true,
                     filterOptions: {
                     enabled: true, // enable filter for this column
                     placeholder: "ID", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     filterDropdownItems: [], // dropdown (with selected values) instead of text input
                     filterFn: this.onColumnFilter, //custom filter function that
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },*/
                    {
                        label: 'First Name',
                        field: 'first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "First Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Last Name',
                        field: 'last_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Last Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Email',
                        field: 'email',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'DayForce Id',
                        field: 'username',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "DayForce Id", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Designation',
                        field: 'role',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Role", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'State',
                        field: 'state',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "State", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location',
                        field: 'location_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Department',
                        field: 'department_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Department", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Last Login',
                        field: 'last_login',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Last Login", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        width: '108px',
                        thClass: 'disable-sorting',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        beforeMount: function () {
            self = this;
            //self.checkLogin();
        },
        mounted: function () {
            $("#subject").on('keyup', function () {
                self.subjectError = '';
            });
            $("#message").on('keyup', function () {
                self.messageError = '';
            });
//            self = this;
            $("#alertError").hide();
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                /*console.log(userJson.id);*/
                self.loginID = userJson.id;
            } else {
                self.logout();
            }
            self.loadHRTeam();
        },
        methods: {
            checkForm: function () {
                var checked = true;

                if (!self.subject) {
                    self.subjectError = "Subject Is Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.message) {
                    self.messageError = "Email Message Is Required";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            gotoDraggableHRList() {
                self.$router.push('/backend/hrdragview');
            },

            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadHRTeam();
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadHRTeam();
                }
            },

            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('first_name');
                    field: ('last_name');
                    field: ('email');
                    field: ('username');
                    field: ('role');
                    field: ('location');
                    field: ('last_login');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.first_name || filters.last_name || filters.email || filters.username || filters.role || filters.location || filters.last_login) {
                    self.loadHRTeam();
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['hrteamList'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadHRTeam();
            },
            deleteHrTeam: function (id) {
                var usedArr = [];
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")}
                };

                if (id) {
                    usedArr.push(id);
                } else {
                    var selectedUser = self.$refs['hrteamList'].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        usedArr.push(self.$refs['hrteamList'].selectedRows[i].id);
                    }
                }
                var fields = {
                    deleteArr: usedArr,
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post("deleteuser", fields, config)
                                .then(function (response) {
                                    self.loadHRTeam();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record(s) still intact', 'info')
                    }
                });
            },
            loadModel: function (action) {
                self.modelTitle = 'Send Email Notification To Selected';
                if (action == 'btnsendmailall') {
                    self.modelTitle = 'Send Email Notification To All';
                }
                self.modelButtonId = action;
                $('#queueEmail').modal('show');
            },
            sendMail: function (e) {
                $("#alertError").hide();
                self.checkForm();
                if (self.checkForm()) {
                    $(e.target).text('Sending...');
                    $(e.target).prop("disabled", true);

                    var selectedCustomers = self.$refs['hrteamList'].selectedRows;
                    var usersArr = [];
                    for (var i = 0; i < selectedCustomers.length; i++) {
                        usersArr.push(self.$refs['hrteamList'].selectedRows[i].id);
                    }
                    self.firstLoad = 1;
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("token")}
                    };
                    var fields = new FormData();
                    fields.append('subject', self.subject);
                    fields.append('message', self.message);
                    fields.append('filters', JSON.stringify(self.serverParams.columnFilters));
                    fields.append('sort', JSON.stringify(self.serverParams.sort));
                    fields.append('users_arr', usersArr);
                    fields.append('send_email', e.target.id);
                    for (var i = 0; i < self.filesAttachment.length; i++) {
                        let file = self.filesAttachment[0];
                        fields.append('attachment', file);
                    }
                    this.$swal({
                        title: 'Are you sure?',
                        text: 'You want to send email notification',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes Send it!',
                        cancelButtonText: 'No, Don\'t send it!',
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    }).then((result) => {
                        if (result.value) {
                            HTTP.post('sendemail', fields, config)
                                    .then(function (response) {
                                        $(e.target).text('Send Notification');
                                        $(e.target).prop("disabled", false);

                                        if (response.data.code == '200') {
                                            self.subject = '';
                                            self.message = '';
                                            self.filesAttachment = [];
                                            $('#upload').val('');
                                            $('#queueEmail').modal('hide');
                                            self.$swal({
                                                type: 'success',
                                                text: 'Email Notification Sent Successfully',
                                                showConfirmButton: false,
                                                timer: 5000,
                                            });
                                            self.loadHRTeam();
                                        }

                                    })
                                    .catch(function (err) {
                                        $(e.target).text('Send Notification');
                                        $(e.target).prop("disabled", false);
                                        //$('#queueEmail').modal('hide');
                                        if (err.response.status == 0) {
                                            self.error = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                self.$router.push("/login");
                                                //EventBus.$emit("logged-in", true, "", "");
                                            } else {
                                                $("#alertError").show();
                                                $("#errorMsg").html(err.response.data.content);
                                                $(".alert-danger").removeClass("hide");
                                                $(".alert-danger").addClass("show");
                                                setTimeout(function () {
                                                    $(".alert-danger").removeClass("show");
                                                    $(".alert-danger").addClass("hide");
                                                }, 5000);
                                            }
                                        }
                                    });
                            /*$('#queueEmail').modal('hide');
                             self.$swal({
                             type: 'success',
                             text: 'Email notification sent successfully',
                             showConfirmButton: false,
                             timer: 5000,
                             });
                             self.loadHRTeam();*/
                        } else {
                            self.$swal('Cancelled', 'Your have cancelled email notification', 'info')
                            $(e.target).text('Send Notification');
                            $(e.target).prop("disabled", false);
                            self.subject = '';
                            self.message = '';
                            self.filesAttachment = [];
                            $('#upload').val('');
                            $('#queueEmail').modal('hide');
                        }
                    });
                }
            },
            loadHRTeam: function () {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")}
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    /*messageData: self.message,*/
                    sort: self.serverParams.sort,
                    export_users: self.exportUsers
                };
                HTTP.post('listuser', fields, config)
                        .then(function (response) {
                            $('#exportUsers').text('Export');
                            $('#exportUsers').prop("disabled", false);
                            if (response.data.message == "success export") {
                                location.href = response.data.content.web;
                            } else if (response.data.code == '200') {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                            }
                            self.exportUsers = false;
                        })
                        .catch(function (err) {
                            $('#exportUsers').text('Export');
                            $('#exportUsers').prop("disabled", false);
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                            self.exportUsers = false;
                        })
            },
            exportUsersData: function () {
                self.exportUsers = true;
                if (self.exportUsers == true) {
                    $('#exportUsers').text('Exporting...');
                    $('#exportUsers').prop("disabled", true);
                    self.loadHRTeam();
                }
            },
            handleFilesUploadAttachment: function () {
                let uploadedFiles = "";
                uploadedFiles = self.$refs.filesAttachment.files;

                for (var i = 0; i < uploadedFiles.length; i++) {
                    self.filesAttachment = [uploadedFiles[i]];
                }
            },

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/backend/user/ListUser.vue